
// constants as defined in RevoXef’s App\Models\Config\PaymentMethod
const CARD = 1
const CASH = 2
const VOID = 3

// From Xef’s ServiceProviders/PaymentMethods/GSPaymentMethodExtensionFactory.m
const DISABLED = [
    'gift card',
    'intouch',
    'intouch points',
    'hotel',
    'hotelgest',
    'medallion',
    'medallion no alojado',
    'demo pms',
    'tesipro room',
    'tesipro visa',
    'tesipro amex',
    'tesipro efectivo',
    'sihot',
    'descuento 100% m',
    'discount 100% m',
    'room charge mews',
    'room charge ingenie',
    'room charge sh',
    'offline room charge sh',
    'acigrup',
    'prodelfi',
    'kymboo',
    'rocketbeds',
    'roomraccoon',
    'ticket restaurant',
    'bracelets',
    'nfc mhi',
    'room charge m',
    'bracelets rooms',
    'hotel cross charge pp',
    'cliente bb',
    'invita bb',
    'cargo alojado bb',
    'autoconsumo bb',
    'mp=pc bb',
    'voucher bb',
    'sodexo 1€',
    'ticket restaurant 1€',
    'cheque gourmet 1€',
    'masteryield',
    'colectividad',
    'coaliment',
    'fakepaymentmethod',
    'guestpro',
    'ulyses',
];

export default {
  CARD,
  CASH,
  VOID,
  isCard: v => v == CARD,
  isCash: v => v == CASH,
  isOther: v => Number.isInteger(v) && [CARD, CASH].indexOf(v) === -1,
  isDisabled: o => DISABLED.indexOf(o.name.toLowerCase()) !== -1,
  isRefundable: v => [CARD, CASH].indexOf(v) !== -1,
}
